import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { refreshSessionPermissions } from "./utils/refreshSessionPermissions";
import "./utils/socket";

function App() {
  useEffect(() => {
    // Đồng bộ quyền từ DB (JWT + localStorage.modules) khi mở app
    refreshSessionPermissions();
  }, []);

  return(
    <BrowserRouter>  
      <AppRoutes />
      <ToastContainer position="top-right" autoClose={3000} />
    </BrowserRouter>
    
  );
}
export default App;
